$(function() {
    var selector = $('.c-navigation__element a, .button');

    // append a span to each nav element <a> tag - used for hovering effect
    selector.each(function (index, elem) {
        var span = document.createElement('span');
        elem.append(span);
    });

    selector
        .on('mouseenter', function(e) {
            var parentOffset = $(this).offset(),
                relX = e.pageX - parentOffset.left,
                relY = e.pageY - parentOffset.top;
            $(this).find('span').css({top:relY, left:relX});
        })
        .on('mouseout', function(e) {
            var parentOffset = $(this).offset(),
                relX = e.pageX - parentOffset.left,
                relY = e.pageY - parentOffset.top;
            $(this).find('span').css({top:relY, left:relX});
        });
});
